import * as swcHelpers from '@swc/helpers';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getLocalizedValue, getAttrValue, getLocalizedAttrValue } from '@grandvisionhq/utils';
import { getPrice } from '../../helpers.js';
import { getDiscount } from '../../utils/get-discount.js';
import { getProductTag } from '../../utils/get-product-tag.js';

function getVariantInfo(locale, product, variant, productType) {
    const isLenses = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
    const isSolutions = CommerceToolsApi.isSolutions(productType);
    const brand = isLenses || isSolutions ? getLocalizedValue(product.name, locale) : String(getAttrValue(variant, 'brand'));
    const name = isLenses ? getLocalizedAttrValue(variant, 'replacementFrequency', locale) : isSolutions ? `${getLocalizedAttrValue(variant, 'contactLensCareType', locale) || ''} ${getAttrValue(variant, 'packageOption') || ''}` : variant.name;
    const { originalPrice , discountedPrice  } = getPrice(variant) || {};
    const framePriceIncluded = CommerceToolsApi.isFrames(productType) && getAttrValue(variant, 'priceIncluded');
    const price = framePriceIncluded && typeof framePriceIncluded === 'object' ? Number(framePriceIncluded.centAmount) : originalPrice;
    return swcHelpers.objectSpread({
        brand: brand || '',
        discounted: getDiscount(variant, locale),
        name: name || '',
        sku: variant.sku,
        price,
        tag: getProductTag(variant, locale)
    }, discountedPrice && discountedPrice !== originalPrice ? {
        discountedPrice
    } : {});
}

export { getVariantInfo };
//# sourceMappingURL=get-variant-info.js.map
